import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./Gallery.css";

// Import images
import image1 from "../assests/image1.png";
import image2 from "../assests/image2.png";
import image3 from "../assests/image3.png";
import image4 from "../assests/image4.png";
import image5 from "../assests/image5.png";
import image6 from "../assests/image6.png";
import image7 from "../assests/image7.png";

function Gallery() {
  return (
    <div className="gallery-container">
      <div className="gallery-header">
        <p className="gallery-title">Make Your Tour More Pleasurable</p>
        <h2 className="gallery-subtitle">Recent Gallery</h2>
      </div>
      <Row className="gallery-row">
        <Col xs={12} sm={2} className="gallery-col" style={{ margin: 10 }}>
          <img src={image1} alt="Houseboat" className="image-medium" />
        </Col>
        <Col xs={12} sm={2} className="gallery-col vertical" style={{ margin: 10 }}>
          <img src={image2} alt="Image 2" className="image-small" />
          <img src={image3} alt="Image 3" className="image-small" />
        </Col>
        <Col xs={12} sm={4} className="gallery-col" style={{ margin: 10 }}>
          <img src={image4} alt="Image 4" className="image-large" />
        </Col>
        <Col xs={12} sm={2} className="gallery-col vertical" style={{ margin: 10 }}>
          <img src={image5} alt="Image 5" className="image-small" />
          <img src={image6} alt="Image 6" className="image-small" />
        </Col>
        <Col xs={12} sm={2} className="gallery-col" style={{ margin: 10 }}>
          <img src={image7} alt="Image 7" className="image-medium" />
        </Col>
      </Row>
    </div>
  );
}

export default Gallery;
